import React from 'react';
import { Route, Switch } from 'react-router-dom';
import routers from '../../configs/routeConfig';
import NotFoundPage from '../NotFoundPage/Loadable';
import AuthenticatedRoute from './AuthenticatedRoute';
import UnAuthenticatedRoute from './UnAuthenticatedRoute';

const Routers: React.FC = (): React.ReactElement => {
  return (
    <Switch>
      {routers.map(route =>
        route.isPrivate ? (
          <AuthenticatedRoute
            title={route.title}
            key={route.path}
            path={route.path}
            component={route.component}
            exact={route.exact}
          />
        ) : (
          <UnAuthenticatedRoute
            key={route.path}
            path={route.path}
            component={route.component}
            exact={route.exact}
          />
        ),
      )}
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default Routers;
